import { jsx as _jsx } from "react/jsx-runtime";
import { Route } from 'react-router';
export function schemaToRoutes(routes) {
    return routes.map(({ component: PageComponent, path, key, children }) => {
        return (_jsx(Route, { path: path, element: _jsx(PageComponent, {}), children: children ? schemaToRoutes(children) : null }, key));
    });
}
